import { createSharedPhaserConfig } from '../../shared/phaser/sharedPhaserConfig';
import { neonRelayDefinition } from './neonRelayDefinition';
import { createNeonRelayScene } from './scenes/RelayScene';

export function createNeonRelayGameConfig({
  Phaser,
  controllerInputRef,
  definition = neonRelayDefinition,
  events = {},
  reducedMotion = false,
  routeIndex = 0,
  score = 0,
  selectedPlayableIcon = 'neon-relay',
}) {
  return createSharedPhaserConfig({
    type: Phaser.AUTO,
    physics: {
      default: 'arcade',
      arcade: {
        debug: false,
      },
    },
    scene: createNeonRelayScene({
      controllerInputRef,
      definition,
      events,
      reducedMotion,
      routeIndex,
      score,
      selectedPlayableIcon,
    }),
  });
}
